import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import { criarClienteTrpc, trpc } from './lib/trpc.js';
import './estilos/index.css';

function Raiz() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Sessão expirada não melhora com retentativa; erro de rede, sim.
            retry: (tentativa, erro) => {
              const codigo = (erro as { data?: { code?: string } }).data?.code;
              if (codigo === 'UNAUTHORIZED' || codigo === 'FORBIDDEN') return false;
              return tentativa < 2;
            },
            staleTime: 30_000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );
  const [trpcClient] = useState(() => criarClienteTrpc());

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </trpc.Provider>
  );
}

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html');

createRoot(raiz).render(
  <StrictMode>
    <Raiz />
  </StrictMode>,
);
